import React, {memo} from "../../../__snowpack__/pkg/react.js";
import {message, Tooltip} from "../../../__snowpack__/pkg/antd.js";
import {copyText} from "../../utils/tools.js";
import Icon from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {copyIcon} from "./copy.js";
import "./index.module.css";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
const CopyText = memo((props) => {
  const {formatMessage} = useIntl();
  const {
    label = "",
    text = "",
    isGray = false,
    styles = {},
    callback,
    hasWrap = false,
    hiddenText,
    titleText = "",
    textCopy = ""
  } = props;
  const handleClick = () => {
    callback && callback();
  };
  const handleCopy = () => {
    const _text = textCopy ? textCopy : text;
    const isCopySuccess = copyText(_text);
    if (isCopySuccess) {
      message.success(formatMessage({id: "success"}));
    }
  };
  return text ? /* @__PURE__ */ React.createElement("div", {
    className: "copy-text-item"
  }, /* @__PURE__ */ React.createElement("div", {
    className: ["copy-ellips", isGray ? "text-gray" : ""].join(" "),
    style: {...styles},
    onClick: handleClick
  }, label, hasWrap && "[", /* @__PURE__ */ React.createElement(Tooltip, {
    title: titleText ? titleText : text,
    getPopupContainer: () => document.body
  }, !hiddenText && /* @__PURE__ */ React.createElement("a", null, text)), hasWrap && "]"), /* @__PURE__ */ React.createElement(Tooltip, {
    title: formatMessage({id: "copyUrl"})
  }, /* @__PURE__ */ React.createElement(Icon, {
    component: copyIcon,
    className: "common-text-copy",
    onClick: handleCopy
  }))) : /* @__PURE__ */ React.createElement("div", {
    className: isGray ? "text-gray" : ""
  }, "--");
});
export default CopyText;
